// extracted by mini-css-extract-plugin
export default {"DepartmentButton":"departmentButton_DepartmentButton__hHvYh","Active":"departmentButton_Active__DLH3m"};